import { render, staticRenderFns } from "./AnnotationChipLeft.vue?vue&type=template&id=613ce729"
import script from "./AnnotationChipLeft.vue?vue&type=script&lang=js"
export * from "./AnnotationChipLeft.vue?vue&type=script&lang=js"
import style0 from "./AnnotationChipLeft.vue?vue&type=style&index=0&id=613ce729&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports